/* ========================================================== */
/* WRX CUSTOM BUILD: CART & PRICE CLEANUP (FORMATTING ONLY) */
/* ========================================================== */
(function() {
  // 1. Whole-Dollar Formatting Function (.00 Stripper)
  function cleanPriceFormatting() {
    // Select cart drawer items and price elements across the page
    const priceElements = document.querySelectorAll(
      '.cart-drawer__price, .cart-item__price, [data-cart-item-price], .price-item, [data-wrx-sale-price]'
    );

    priceElements.forEach(el => {
      if (el && el.innerHTML && el.innerHTML.includes('.00')) {
        el.innerHTML = el.innerHTML.replace(/\.00/g, '');
      }
    });
  }

  // 2. Execution Listeners for Cart Updates & Page Loads
  document.addEventListener('DOMContentLoaded', cleanPriceFormatting);
  document.addEventListener('cart:updated', cleanPriceFormatting);
  document.addEventListener('cart:refresh', cleanPriceFormatting);

  // Catch dynamic cart drawer opens/updates
  document.addEventListener('submit', (e) => {
    if (e.target && e.target.action && e.target.action.includes('/cart')) {
      setTimeout(cleanPriceFormatting, 300);
    }
  });
})();